// import {extent as d3_extent} from 'd3-array'
import { select as d3_select } from 'd3-selection'
import drawGradientRect from '../utils/drawGradientRect'

import checkbox_icon from '../styles/icons/icon-checkbox-checked.svg'
import { mapAccessibleColor } from '../utils/colorUtils'
import {
  drawDentedRect,
  drawSvgCircle,
  drawSvgPlus,
  drawSvgPolygon,
  drawSvgSquare,
  drawSvgStar,
  drawSvgTriangle,
} from '../utils/shapeUtils'
import * as COLORS from '../utils/colorUtils'
import { ACCESSIBILITY_OPTIONS_KEYS } from '../utils/accessibilityUtils'
import { isDarkMode } from '../utils/configUtils'
import { dentedRect } from '../utils/pathUtils'

function uniq(arr, id = d => d.id) {
  const icon = arr.icon
  const res = arr.filter((d, i) => arr.findIndex(dd => id(dd) === id(d)) === i)
  res.icon = icon
  return res
}
function LegendBehavior($root, chart, config = {}) {
  if (!chart.data) return
  if (!config.interactive && chart._parent.hiddenItems?.length) chart._parent.hiddenItems = []

  let drawLegend = function (legend, d) {
    let legendData = d.data

    if (d.type === 'sequential2' || d.type === 'sequential3') {
      let size = { width: 90, height: 15 }

      drawGradientRect(legend.node(), chart.cachedColorScale, size)

      let labels = legend.selectAll('.label').data(['l', 'r'])
      labels = labels.merge(
        labels
          .enter()
          .append('div')
          .attr('class', 'label')
          .each(function (d) {
            d === 'l' && d3_select(this).lower()
          })
      )
      labels
        .style('margin', '0 5px')
        .style(
          'font-size',
          chart._parent.accessibilityOptions?.[ACCESSIBILITY_OPTIONS_KEYS.increaseTextSize]
            ? '18px'
            : '14px'
        )
      labels.text(d => {
        let unit = chart.getUnit()
        return d === 'l'
          ? chart.cachedColorScale.domain()[0]
          : chart.cachedColorScale.domain()[1] + (unit ? ' ' + unit : '')
      })
    } else if (
      d.type === 'categorical' ||
      d.type === 'categorical2' ||
      d.type === 'variation' ||
      d.__forceDraw__
    ) {
      let items = legend.selectAll('.legend-item').data(legendData, d => d.id)
      let itemsEnter = items
        .enter()
        .append('div')
        .attr('class', 'legend-item')
        .style('display', 'flex')
        .style('gap', '8px')
        .style('align-items', 'center')
        .style('margin', '5px')

      // al a mierda la transicion... estropea el "sizeHelper"
      // items.exit().each(function (d) {
      //   let sel = d3_select(this)
      //   let rect = this.getBoundingClientRect()
      //   sel.style('top',rect.top+'px').style('left',rect.left+'px').style('position','absolute')
      // }).transition().style('opacity',0).remove()
      items.exit().style('opacity', 0).remove()

      itemsEnter.append('div').attr('class', 'icon').style('margin', '6px 0px 4px 4px') //.style('width', '10px').style('height', '10px')

      itemsEnter.append('div').attr('class', 'label')

      items = items.merge(itemsEnter)

      //HAy que resetarelo cada vez (items vs itemsEnter) para que legendData sea la "buena"
      items.on('click', (e, d) => {
        if (chart.config.LegendBehavior.interactive) {
          if (chart._parent.hiddenItems.indexOf(d.id) >= 0)
            chart._parent.hiddenItems = chart._parent.hiddenItems.filter(hi => hi !== d.id)
          else {
            if (chart._parent.hiddenItems.length < legendData.length - 1) {
              chart._parent.hiddenItems = chart._parent.hiddenItems.concat([d.id])
            }
          }
        }
        if (chart) chart.emit('labelClick', d)
      })

      items.style('cursor', chart.config.LegendBehavior.interactive ? 'pointer' : 'default')

      items
        .select('.label')
        .text(d => d.id)
        .style(
          'font-size',
          chart._parent.accessibilityOptions?.[ACCESSIBILITY_OPTIONS_KEYS.increaseTextSize]
            ? '18px'
            : '14px'
        )

      let icon = d.data.icon || config.icon
      let hasPattern = false
      items.each(function (itemDatum, index) {
        const isLineItem = icon === 'line'
        const keyDict = isLineItem ? 'id' : 'group'

        const itemKey = itemDatum[keyDict] || itemDatum['id']
        if (isLineItem && Array.isArray(chart.config.ItemsHelper.colorDict))
          hasPattern =
            hasPattern || !!chart.config.ItemsHelper.colorDict?.[0]?.[itemKey]?.pattern?.svg
        else {
          //para lines and bars
          const colorDict = Array.isArray(chart.config.ItemsHelper.colorDict)
            ? chart.config.ItemsHelper.colorDict[1]
            : chart.config.ItemsHelper.colorDict
          hasPattern = hasPattern || colorDict?.[itemKey]?.pattern?.svg
        }
      })

      items.each(function (itemDatum, index) {
        const isLineItem = icon === 'line'
        const keyDict = isLineItem ? 'id' : 'group'
        let shapedIcon

        const itemKey = itemDatum[keyDict] || itemDatum['id']
        if (chart.config.ItemsHelper.colorDict) {
          if (isLineItem && Array.isArray(chart.config.ItemsHelper.colorDict))
            shapedIcon = chart.config.ItemsHelper.colorDict?.[0]?.[itemKey]?.shape
          else shapedIcon = chart.config.ItemsHelper.colorDict?.[itemKey]?.shape
        }

        if (!shapedIcon)
          shapedIcon = icon === 'square' ? 'dentedRect' : isLineItem ? 'circle' : icon

        const SVG_SIZE =
          d.legendType === 'size' ? itemDatum.value : isLineItem ? 20 : hasPattern ? 25 : 10
        const SVG_LINE_SHAPE_SIZE = 10

        const drawSvgShapes = (className, shapeType, drawEnterCb, drawMergeCb) => {
          let svgShape = d3_select(this).select('.icon').selectAll('.shape').data([itemDatum])
          const svgShapeEnter = svgShape.enter().append('svg').attr('class', 'shape')

          svgShape.exit().remove()
          svgShape = svgShape.merge(svgShapeEnter)
          svgShape.attr('width', SVG_SIZE).attr('height', SVG_SIZE)

          let shapes = svgShape
            .selectAll(`.${className}`)
            .data(shapedIcon === shapeType ? [itemDatum] : [], dd => dd.id)
          const shapesEnter = shapes
            .enter()
            .append('g')
            .attr('class', className)
            .attr('stroke-width', isLineItem ? 1 : 0)
          shapes.exit().remove()
          shapes = shapes.merge(shapesEnter)
          shapes.attr(
            'transform',
            shapeType !== 'dentedRect' ? `translate(${SVG_SIZE / 2}, ${SVG_SIZE / 2})` : undefined
          )

          //Draw background line if needed
          let lineShape = shapes.selectAll('.line-shape').data(isLineItem ? [null] : [])
          const lineShapeEnter = lineShape
            .enter()
            .append('line')
            .attr('class', 'line-shape')
            .attr('x1', -SVG_SIZE / 2)
            .attr('x2', SVG_SIZE / 2)
            .attr('y1', 0)
            .attr('y2', 0)
            .attr('stroke-width', 2)
          lineShape.exit().remove()
          lineShape = lineShape.merge(lineShapeEnter)

          //Draw shapes
          shapesEnter.call(drawEnterCb)
          shapes
            .attr(
              'fill',
              isLineItem
                ? !isDarkMode(chart.config, chart._parent.accessibilityOptions)
                  ? COLORS.SKIN_BACKGROUND
                  : COLORS.SKIN_BACKGROUND_DARK
                : dd => chart.fill(dd, d.index)
            )
            .attr('stroke', dd => chart.color(dd, d.index))
            .call(drawMergeCb)
        }

        /*
        const drawDentedRect = className => {
          let shapes = d3_select(this)
            .select('.icon')
            .selectAll(`.${className}`)
            .data(shapedIcon === 'dentedRect' ? [itemDatum] : [], dd => dd.id)
          const shapesEnter = shapes
            .enter()
            .append('div')
            .attr('class', `icon-shape ${className}`)
            .style('border-radius', '3px 0 3px 0')
            .style('display', 'flex')
            .style('align-items', 'center')
            .style('justify-content', 'center')

          shapes.exit().remove()
          shapes = shapes.merge(shapesEnter)

          shapes
            .style('width', `${SVG_SIZE}px`)
            .style('height', `${SVG_SIZE}px`)
            .style('background-color', dd => chart.color(dd, d.index))

          let shapesPattern = shapes.selectAll('.pattern-wrapper').data(dd => {
            const patternSvg = chart.config.ItemsHelper?.colorDict?.[dd.id]?.pattern?.svg
            return patternSvg ? [{ data: dd, patternSvg: patternSvg }] : []
          })

          const shapesPatternEnter = shapesPattern
            .enter()
            .append('svg')
            .attr('width', '100%')
            .attr('height', '100%')
            .attr('class', 'pattern-wrapper')
          shapesPattern.exit().remove()

          shapesPattern = shapesPattern.merge(shapesPatternEnter)
          shapesPattern.html(d => d.patternSvg)
          shapesPattern.select('svg').attr('fill', dd => {
            return isDarkMode(chart.config) ? COLORS.SKIN_BACKGROUND_DARK : COLORS.SKIN_BACKGROUND
          })
        }
        //Dented rect
        drawDentedRect('dented-rect')
        */

        //DentedRect
        drawSvgShapes(
          'dentedRect',
          'dentedRect',
          sel => drawDentedRect(sel, SVG_SIZE, 'enter'),
          sel => drawDentedRect(sel, SVG_SIZE, 'edit')
        )

        //Circle
        drawSvgShapes(
          'circle',
          'circle',
          sel => drawSvgCircle(sel, 0, 'enter'),
          sel => {
            return drawSvgCircle(sel, (isLineItem ? SVG_LINE_SHAPE_SIZE : SVG_SIZE) / 2, 'edit')
          }
        )

        //Square
        drawSvgShapes(
          'square',
          'square',
          sel => drawSvgSquare(sel, 0, 'enter'),
          sel => drawSvgSquare(sel, isLineItem ? SVG_LINE_SHAPE_SIZE : SVG_SIZE, 'edit')
        )
        //Triangles
        drawSvgShapes(
          'triangle',
          'triangle',
          sel => drawSvgTriangle(sel, 0, 'enter'),
          sel => drawSvgTriangle(sel, isLineItem ? SVG_LINE_SHAPE_SIZE : SVG_SIZE, 'edit')
        )

        //Five point star
        drawSvgShapes(
          'five-point-star',
          'fivePointStar',
          sel => drawSvgStar(sel, 0, 5, 'enter'),
          sel => drawSvgStar(sel, isLineItem ? SVG_LINE_SHAPE_SIZE : SVG_SIZE, 5, 'edit')
        )

        //Six point star
        drawSvgShapes(
          'six-point-star',
          'sixPointStar',
          sel => drawSvgStar(sel, 0, 6, 'enter'),
          sel => drawSvgStar(sel, isLineItem ? SVG_LINE_SHAPE_SIZE : SVG_SIZE, 6, 'edit')
        )

        //Hexagon
        drawSvgShapes(
          'hexagon',
          'hexagon',
          sel => drawSvgPolygon(sel, 0, 6, 'enter'),
          sel => drawSvgPolygon(sel, isLineItem ? SVG_LINE_SHAPE_SIZE : SVG_SIZE, 6, 'edit')
        )

        //Pentagon
        drawSvgShapes(
          'pentagon',
          'pentagon',
          sel => drawSvgPolygon(sel, 0, 5, 'enter'),
          sel => drawSvgPolygon(sel, isLineItem ? SVG_LINE_SHAPE_SIZE : SVG_SIZE, 5, 'edit')
        )

        //Plus
        drawSvgShapes(
          'plus',
          'plus',
          sel => drawSvgPlus(sel, 0, 'enter'),
          sel => drawSvgPlus(sel, isLineItem ? SVG_LINE_SHAPE_SIZE : SVG_SIZE, 'edit')
        )
      })

      let checkbox = items.selectAll('.checkbox').data(
        d => (chart.config.LegendBehavior.interactive ? [d] : []),
        d => d.id
      )
      let checkboxEnter = checkbox
        .enter()
        .append('div')
        .attr('class', 'checkbox')
        .style('position', 'relative')
        .lower()
      checkboxEnter.append('div').attr('class', 'border rounded-rect')
      checkboxEnter.each(function (d) {
        let svg = new DOMParser().parseFromString(checkbox_icon, 'image/svg+xml').documentElement
        // const { x, y, width, height } = svg.viewBox.baseVal
        svg.setAttribute('class', 'tick')
        svg.setAttribute('height', 8)
        svg.setAttribute('width', 8)
        this.append(svg)
      })
      checkbox.exit().remove()
      checkbox = checkbox.merge(checkboxEnter)

      checkbox.style('margin', '6px 4px 4px 12px')
      checkbox
        .select('.border')
        .style('width', '20px')
        .style('height', '20px')
        .style('border-radius', '4px')

      checkbox
        .select('.border')
        .style(
          'border-color',
          dd => `${mapAccessibleColor(chart.color(dd, d.index), chart.config.skin)}`
        )
        .style('border-width', '2px')
        .style('border-style', 'solid')
      checkbox
        .select('svg')
        .style('position', 'absolute')
        .style('top', '50%')
        .style('left', '50%')
        .style('transform', 'translate(-50%,-50%)')
        .select('path')
        .attr('stroke', dd => `${mapAccessibleColor(chart.color(dd, d.index), chart.config.skin)}`)
        .style('opacity', dd => {
          return chart._parent?.hiddenItems?.indexOf(dd.id) >= 0 ? 0 : 1
        })
    } else if (d.type === 'size') {
      let items = legend.selectAll('.legend-item').data(legendData)
      let itemsEnter = items
        .enter()
        .append('div')
        .attr('class', 'legend-item')
        .style('display', 'flex')
        .style('align-items', 'center')
        .style('margin', '5px')
      items.exit().remove()

      itemsEnter.append('div').attr('class', 'icon').style('width', '10px').style('height', '10px')

      itemsEnter
        .append('div')
        .attr('class', 'label')
        .style(
          'font-size',
          chart._parent.accessibilityOptions?.[ACCESSIBILITY_OPTIONS_KEYS.increaseTextSize]
            ? '18px'
            : '14px'
        )
      items = items.merge(itemsEnter)

      items.select('.label').text(d => d[this.config.legendAttr])
      items
        .select('.icon')
        .style('margin', '6px 8px 4px 4px') //BASURA ESTE 6px, (es porque la fuente no esta "bien centrada" creo)
        .transition()
        .style('background', '#ddd')

      items
        .select('.icon')
        .classed('circle', true)
        .style('width', d => d.value + 'px')
        .style('height', d => d.value + 'px')
        .style('border-radius', d => d.value + 'px')
    }
  }

  let legendDatas = (chart.getLegendData && chart.getLegendData()) || chart.allData || chart.data

  if (Array.isArray(legendDatas))
    legendDatas = [{ id: chart.config.ItemsHelper.colorScale, data: uniq(legendDatas) }]
  else
    legendDatas = Object.keys(legendDatas).map((key, i) => ({
      id: chart.config.ItemsHelper.colorScale[i] + '_' + key,
      data: uniq(legendDatas[key]),
      __forceDraw__: legendDatas[key].__forceDraw__,
      legendType: legendDatas[key].type,
    }))
  legendDatas.forEach((ld, i) => {
    ld.type =
      ld.data.type || Array.isArray(chart.config.ItemsHelper.colorScale)
        ? chart.config.ItemsHelper.colorScale[i]
        : chart.config.ItemsHelper.colorScale
    ld.index = i
  })

  let legends = d3_select($root)
    .selectAll('.legend')
    .data(legendDatas, d => d.id)
  legends.exit().remove()
  let legendsEnter = legends.enter().append('div').attr('class', 'legend')
  legendsEnter.style('opacity', 0).transition().duration(1000).style('opacity', 1)
  legends = legends.merge(legendsEnter)
  legends
    .style('display', 'flex')
    .style('flex-wrap', 'wrap')
    .style('align-items', 'center')
    .style('margin-top', '5px')

  legends.each(function (d) {
    drawLegend(d3_select(this), d)
  })
}

LegendBehavior.defaultConfig = {
  index: 201,
  /**
   * {-EN-} Show or hide the legend of the chart.
   * {-ES-} Muestra u oculta la leyenda del gráfico.
   */
  showLegend: {
    type: Boolean,
    default: false,
    exposed: true,
  },
  icon: {
    type: [String],
    options: ['square', 'circle', 'line'],
    default: 'square',
  },
  legendAttr: {
    type: String,
    default: 'id',
    exposed: false,
  },
  interactive: {
    type: Boolean,
    default: false,
    exposed: true,
  },
}
LegendBehavior.configName = 'LegendBehavior'

export default LegendBehavior
